export const getIsDialogOpen = (state, { dialogType }) => state.sessionsPage.dialogs.dialogType === dialogType
export const getDialogPayload = (state, { dialogType }) => state.sessionsPage.dialogs.payload
